var React = require('react');

function PatternSea (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pattern/Circual/Light/Green Copy"),React.createElement("path",{"d":"M1.313 30.5L25.485.05l23.44 29.406L73.1.05l22.708 29.406L119.248.05l23.44 29.406M1.313 71.1l24.173-30.45 23.44 29.406L73.1 40.65l22.708 29.406 23.44-29.406 23.44 29.406M1.313 111.7l24.173-30.45 23.44 29.406L73.1 81.25l22.708 29.406 23.44-29.406 23.44 29.406M1.313 152.3l24.173-30.45 23.44 29.406L73.1 121.85l22.708 29.406 23.44-29.406 23.44 29.406","fill":"none","key":1})]);
}

PatternSea.defaultProps = {"width":"144","height":"153","viewBox":"0 0 144 153"};

module.exports = PatternSea;

PatternSea.default = PatternSea;
